var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.industry,"label":_vm.$t('product-finder.industry-placeholder'),"hide-details":"","outlined":""},on:{"click":function($event){return _vm.onIndustryClick()},"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }